import { useEffect, useRef } from "react";

import { createRecordingToast } from "components/shared/toasts";
import { useAppSelector } from "hooks/redux_hooks";
import { RecordingStateType } from "shared/types";
import { classroomSelectors } from "store";

// Observes recording session state so toast notifications can be dispatched
function RecordingObserver() {
  const recordingSessionId = useAppSelector(classroomSelectors.selectRecordingSessionId());
  const recordingState = useAppSelector(classroomSelectors.selectRecordingState());
  const prevRecordingSessionId = useRef(recordingSessionId);
  const prevRecordingState = useRef(recordingState);

  useEffect(() => {
    const newRecordingSession = prevRecordingSessionId.current !== recordingSessionId;
    if (newRecordingSession) {
      prevRecordingSessionId.current = recordingSessionId;
      if (
        recordingState === RecordingStateType.Preparing ||
        recordingState === RecordingStateType.Starting
      ) {
        // Recording was manually started
        createRecordingToast(
          "Preparing Recording",
          "Preparing to record this class, please wait...",
        );
      }
    }
  }, [recordingSessionId, recordingState]);

  useEffect(() => {
    const userJustEntered = prevRecordingState.current === recordingState;
    if (userJustEntered) {
      if (recordingState === RecordingStateType.Recording) {
        // Recording started before user joined class
        createRecordingToast("Recording", "This class is being recorded.");
      }
    } else {
      prevRecordingState.current = recordingState;
      if (recordingState === RecordingStateType.Recording) {
        // Recording started either automatically or manually
        createRecordingToast("Recording Started", "This class is now being recorded.");
      } else if (recordingState === RecordingStateType.NotRecording) {
        // Recording manually stopped
        createRecordingToast("Recording Stopped", "This class is no longer being recorded.");
      }
    }
  }, [recordingState]);

  return null;
}

export { RecordingObserver };
